import { createContext, useReducer } from "react";

class FormData {
    id: string;
    name: string;
    remark: string;
}

type Dispatch = { type, payload }

interface IState {
    formData: FormData;
}

const initialArgs = {
    formData: new FormData()
}

export type FormAttribute = "Name" | "Remark";

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

export const RoleFormStore = createContext<IContextProps>(null);

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        // 填充表单
        case "SetForm":
            {
                const data = payload;
                const form = new FormData();

                {
                    const {id,name,remark } = data;
                    form.id = id;
                    form.name = name;
                    form.remark = remark;

                }

                return {
                    ...state,
                    formData: form
                }
            }
        // 设置表单
        case "Change_FormData":
            {
                const { attribute, value } = payload, props: any = {};

                const key: FormAttribute = attribute;
                let attri = "";

                switch (key) {
                    case "Name":
                        attri = "name";
                        break;
                    case "Remark":
                        attri = "remark";
                        break;
                    default:
                        break;
                }

                props[attri] = value;

                return {
                    ...state,
                    formData: {
                        ...state.formData,
                        ...props
                    }
                }
            }
        default:
            return state;
    }
}

export function RoleFormStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <RoleFormStore.Provider value={v}>{props.children}</RoleFormStore.Provider>
}